import Swiper from 'swiper/js/swiper.min';
export default {
  init: function init() {
    //gradient video positioning
    function gradientPosition() {
      var headerHeight = $("#header").height() + parseFloat($('#header').css('padding-top')) + parseFloat($('#header').css('padding-bottom'));
      $('#banner .gradient-background').css('top', '-' + headerHeight + 'px');
    }

    gradientPosition();
    $(window).on('resize', function () {
      gradientPosition();
    });
    var bannerSwiper = new Swiper('#banner .swiper-container', {
      speed: 1000,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: '#banner .next',
        prevEl: '#banner .back'
      },
      noSwiping: true,
      noSwipingClass: 'swiper-slide'
    });
    bannerSwiper.on('slideChange', function () {
      var totalSlides = $('#banner .swiper-slide').length;
      var activeSlide = $('#banner .swiper-slide')[bannerSwiper.activeIndex];

      if (bannerSwiper.activeIndex > 0) {
        $('#banner .swiper-navigation').addClass('hide-skip');
        $('#banner .swiper-navigation').removeClass('hidden');
        $('#banner .lastslide-arrow').removeClass('visible');
      }

      if (bannerSwiper.activeIndex >= totalSlides - 1) {
        $('#banner .swiper-navigation').addClass('hidden');
        $('#banner .lastslide-arrow').addClass('visible');
      }

      if (bannerSwiper.activeIndex > 0 && bannerSwiper.activeIndex < totalSlides - 1) {
        setTimeout(function () {
          $('#banner .swiper-container').addClass('multiply');
        }, 100);
      } else {
        setTimeout(function () {
          $('#banner .swiper-container').removeClass('multiply');
        }, 500);
      }

      var slideVideos = $('#banner video');
      setTimeout(function () {
        if ($(activeSlide).find('video').length > 0) {
          $(activeSlide).find('video')[0].pause();
          $(activeSlide).find('video')[0].currentTime = 0;
          $(activeSlide).find('video')[0].play();
        }
      }, 250);
    });
    $('.skip').on('click', function () {
      var totalSlides = $('#banner .swiper-slide').length;
      bannerSwiper.slideTo(totalSlides - 1);
    });
    $('.restart').on('click', function () {
      var totalSlides = $('#banner .swiper-slide').length;
      bannerSwiper.slideTo(totalSlides - 2);
      $('#banner .swiper-navigation').removeClass('hidden');
    }); //Parallax Section

    $('#activation-kits-section .activation-kits-container').addClass('parallax');
    var windowHeight = $(window).height();
    var parallaxTop = $('.parallax-container').offset().top;
    var parallaxBottom = $('.parallax-container').offset().top - $('.parallax-container').height() - $(window).height();
    var prevScroll = 0;
    var scrollDirection = 'down';
    $(window).on('scroll', function () {
      var scrollPosition = $(window).scrollTop();

      if (scrollPosition > prevScroll) {
        scrollDirection = 'down';
      } else {
        scrollDirection = 'up';
      }

      var offset = scrollPosition - parallaxTop;

      if (offset > 0 && offset <= $('.parallax-placeholder').height()) {
        $('#activation-kits-section .col').css('transform', 'translateY(-' + offset + 'px)');
      } else if (offset < 0) {
        $('#activation-kits-section .col').css('transform', 'translateY(0)');
      }
    });
    $(window).on('load', function () {
      var scrollPosition = $(window).scrollTop();
      var offset = scrollPosition - parallaxTop;
      $('#activation-kits-section .col').css('transform', 'translateY(-' + (offset + 10) + 'px)');
    }); //Filters

    $('.filter').on('click', function () {
      var parent = $(this).parents('.filter-option');
      $('.filter-option').not(parent).removeClass('show');
      parent.toggleClass('show');
    });
    $('.filter-option ul button').on('click', function () {
      $(this).parents('.filter-option').removeClass('show');
      $(this).parents('ul').prev().html($(this).html());
    });
  }
};


// WEBPACK FOOTER //
// ./scripts/routes/activation-kit-landing.js